<template>
  <el-row :gutter="40" class="panel-group">
    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-message">
          <img src="@/assets/icon-home-01.png" alt="">
        </div>
        <count-to :start-val="0" :end-val="childrenData.fieldCount" :duration="2800" :decimals="0" class="card-panel-num"/>
        <div class="card-panel-icon-wrapper icon-message">
          <div class="title">场地总数</div>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-message">
          <img src="@/assets/icon-home-02.png" alt="">
        </div>
        <count-to :start-val="0" :end-val="childrenData.todayAmount" :duration="3000" :decimals="4" class="card-panel-num"/>
        <div class="card-panel-icon-wrapper icon-message">
          <div class="title">今日收益(元)</div>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-message">
          <img src="@/assets/icon-home-03.png" alt="">
        </div>
        <count-to :start-val="0" :end-val="childrenData.thisMonth" :duration="3200" :decimals="4" class="card-panel-num"/>

        <div class="card-panel-icon-wrapper icon-message">
          <div class="title">本月收益(元)</div>
        </div>
      </div>
    </el-col>
    <!-- <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-message">
          <div class="title">历史总收入(元)</div>
        </div>
        <div class="card-panel-description">
          <count-to :start-val="0" :end-val="childrenData.hisAmount" :duration="3200" :decimals="4" class="card-panel-num"/>
        </div>
      </div>
    </el-col> -->
    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-message">
          <img src="@/assets/icon-home-04.png" alt="">
        </div>
        <count-to :start-val="0" :end-val="childrenData.userCount" :duration="3200" :decimals="0" class="card-panel-num"/>
        <div class="card-panel-icon-wrapper icon-message">
          <div class="title">用户总数</div>
        </div>
      </div>
    </el-col>

    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-message">
          <img src="@/assets/icon-home-05.png" alt="">
        </div>
        <count-to :start-val="0" :end-val="childrenData.boxCount" :duration="3200" :decimals="0" class="card-panel-num"/>

        <div class="card-panel-icon-wrapper icon-message">
          <div class="title">柜门总数</div>
        </div>
      </div>
    </el-col>

    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-message">
          <img src="@/assets/icon-home-06.png" alt="">
        </div>
        <count-to :start-val="0" :end-val="childrenData.amount" :duration="3200" :decimals="4" class="card-panel-num"/>

        <div class="card-panel-icon-wrapper icon-message">
          <div class="title">总收益(元)</div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import CountTo from 'vue-count-to'
export default {
  components: {
    CountTo
  },
  props: {
    childrenData: {
      type: Object,
      default: function() {
        return {
          today: 0,
          thisYear: 0,
          threeMonth: 0,
          roleId: null
        }
      }
    }
  },
  created() {
    this.roleId = this.$store.getters.roles.RoleId
  },
  methods: {
    handleSetLineChartData(type) {
      console.log(type)
      this.$emit('handleSetLineChartData', type)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  margin-top: 18px;
  .card-panel-col{
    margin-bottom: 32px;
  }
  .card-panel {
    height: 180px;
    cursor: pointer;
    font-size: 24px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    // &:hover {
    //   .card-panel-icon-wrapper {
    //     color: #fff;
    //   }
    //   .icon-people {
    //      background: #40c9c6;
    //   }
    //   .icon-message {
    //     background: #36a3f7;
    //   }
    //   .icon-money {
    //     background: #f4516c;
    //   }
    //   .icon-shopping {
    //     background: #34bfa3
    //   }
    // }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shopping {
      color: #34bfa3
    }
    .card-panel-icon-wrapper {
      transition: all 0.38s ease-out;
      border-radius: 6px;
      .title{
        font-size: 16px;
        color: black;
      }
    }
    .card-panel-icon {
      font-size: 48px;
    }
    .card-panel-description {
      font-weight: bold;
      margin-left: 0px;
      text-align: right;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

    }
  }
}
.card-panel-num {
  font-size: 22px;
  color: black;
}
</style>
